const state = {
  accessToken: '',
  loginData: {
    userNo: '',
    userId: '',
    name: '',
    email: ''
  },
  keepAlive: null
};
export default state;
